<template>
    <BreadCrumb PageTitle="Liste des Régimes" />
    <ListeRegime/>
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeRegime from "@/components/RegimeDouanier/ListeRegime.vue";

    export default defineComponent({
        name: "ListeRegimePage",
        components: {
            BreadCrumb,
            ListeRegime,
        },
    });
</script>